import React, { useContext } from "react";
import styled from "styled-components";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import { APIContext } from "../../contexts/APIContext";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { Button } from "../../Theme/Hyper";

const TeamNamePanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 7vh;
`;
const Team = styled.div`
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  display: flex;
  width: 45%;
  height: 72px;
`;
const Middle = styled.div`
  display: flex;
  width: 10%;
  justify-content: space-evenly;
  align-items: center;
  margin-top: -10px;
`;
const TeamName = styled.div`
  padding-left: ${(props) => (props.home ? "0.5em" : "")};
  margin-left: ${(props) => (props.home ? "auto" : "")};
  display: flex;
  font-size: 1.5em;
  cursor: pointer;
`;
const Score = styled.div`
  display: flex;
  font-size: 2em;
  padding-left: 1em;
  padding-right: 1em;
  justify-content: center;
  border-radius: 2px;
`;

const Red = styled.div`
  display: flex;
  width: 40px;
  height: 20px;
  background-color: ${({ selected }) => (selected ? "#d93232" : "")};
  border: 1px solid #d93232;
  margin: 5px;
  border-radius: 2px;
  cursor: pointer;
  :hover {
    background-color: #d93232;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const ScoreButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px;
  height: 100%;
  min-width: 100px;
  opacity: ${(props) => (props.selected || !props.red ? "1" : "0.2")};
  background-color: ${(props) => (props.red ? "#e51b4c" : "")};
`;

const RedButton = styled(ScoreButton)`
  margin-left: 10px;
`;
export default function EFLTeamNames({
  setGoalScored,
  game,
  setSelectedPlayer,
  group,
}) {
  const {
    setView,
    selectedTeam,
    setGoal,
    setSelectedTeam,
    homeScorers,
    setHomeScorers,
    awayScorers,
    setAwayScorers,
    periods,
  } = useContext(UIContext);
  const { updateGame } = useContext(APIContext);

  let homeBGColour =
    game.home_team?.variables?.[game?.home_team_kit + "_kit_bg"] || "";
  let awayBGColour =
    game.away_team?.variables?.[game?.away_team_kit + "_kit_bg"] || "";

  return (
    <TeamNamePanel>
      <Team
        style={{
          borderBottom:
            "3px solid " + (homeBGColour ? homeBGColour : "rgba(0,0,0,0)"),
          opacity:
            !selectedTeam || selectedTeam._id === game.home_team._id
              ? "1"
              : ".2",
        }}
      >
        <Column
          onClick={() => {
            if (selectedTeam) {
              setSelectedTeam();
            } else {
              setSelectedTeam(game.home_team);
            }
          }}
        >
          <TeamName>{game.home_team.name}</TeamName>
          <div>{game.home_formation?.name ?? "No formation selected"}</div>
        </Column>

        <Column>
          <Row style={{ marginLeft: "auto" }}>
            <ScoreButton
              onClick={() => {
                if (homeScorers?.length - 1 >= 0) {
                  let newScorers = [...homeScorers];
                  if (awayScorers && awayScorers.length > 0) {
                    newScorers = newScorers.concat(
                      awayScorers.filter((g) => g.own_goal)
                    );
                  }

                  let latestGoals = newScorers.sort((a, b) => {
                    return b.time - a.time;
                  });
                  if (latestGoals.length > 0) {
                    newScorers = homeScorers.filter(
                      (g) => g !== latestGoals[0]
                    );
                    setHomeScorers(newScorers);
                    updateGame({
                      id: game._id,
                      home_scorers: newScorers,
                    });
                  }
                }
              }}
            >
              -
            </ScoreButton>
            <Score
              onContextMenu={(e) => {
                e.preventDefault();
              }}
            >
              {homeScorers?.length ?? 0}
            </Score>
            <ScoreButton
              onClick={() => {
                let period = periods.sort((a, b) => b.number - a.number)[0];
                let time = period?.kick_off ? Date.now() - period?.kick_off : 0;
                if (period.number === 2) {
                  time += 1000 * 60 * (game?.config?.half_duration || 45);
                }
                if (period.number === 3) {
                  time += 1000 * 60 * ((game?.config?.half_duration || 45) * 2);
                }
                if (period.number === 4) {
                  time += 1000 * 60 * 105;
                }
                let _id = Date.now();
                setHomeScorers([
                  ...homeScorers,
                  { time: time, _id, period: period.number },
                ]);
                updateGame({
                  id: game._id,
                  home_scorers: [
                    ...homeScorers,
                    { time: time, _id, period: period.number },
                  ],
                });
              }}
            >
              +
            </ScoreButton>
          </Row>
        </Column>
      </Team>
      <Middle>
        <Column>
          <Row>
            <Column>
              {game?.leg === 2 && (
                <Row style={{ justifyContent: "center" }}>1st leg</Row>
              )}
              {game?.leg === 2 && (
                <Row style={{ justifyContent: "center" }}>
                  {game?.agg_home_score} - {game?.agg_away_score}
                </Row>
              )}
            </Column>
            <Column>
              {game?.leg === 2 && (
                <Row style={{ justifyContent: "center" }}>Agg</Row>
              )}
              {game?.leg === 2 && (
                <Row style={{ justifyContent: "center" }}>
                  {game?.agg_home_score + (homeScorers?.length ?? 0)} -{" "}
                  {game?.agg_away_score + (awayScorers?.length ?? 0)}
                </Row>
              )}
            </Column>
          </Row>
        </Column>
      </Middle>
      <Team
        style={{
          borderBottom:
            "3px solid " + (awayBGColour ? awayBGColour : "rgba(0,0,0,0)"),
          opacity:
            !selectedTeam || selectedTeam._id === game.away_team._id
              ? "1"
              : ".2",
        }}
      >
        <Column>
          <Row style={{ marginRight: "auto" }}>
            <ScoreButton
              onClick={() => {
                if (awayScorers?.length - 1 >= 0) {
                  let newScorers = [...awayScorers];
                  if (homeScorers && homeScorers.length > 0) {
                    newScorers = newScorers.concat(
                      homeScorers.filter((g) => g.own_goal)
                    );
                  }

                  let latestGoals = newScorers.sort((a, b) => {
                    return b.time - a.time;
                  });
                  if (latestGoals.length > 0) {
                    newScorers = awayScorers.filter(
                      (g) => g !== latestGoals[0]
                    );
                    setAwayScorers(newScorers);
                    updateGame({
                      id: game._id,
                      away_scorers: newScorers,
                    });
                  }
                }
              }}
            >
              -
            </ScoreButton>
            <Score
              onContextMenu={(e) => {
                e.preventDefault();
              }}
            >
              {awayScorers?.length ?? 0}
            </Score>
            <ScoreButton
              onClick={() => {
                let period = periods.sort((a, b) => b.number - a.number)[0];
                let time = period?.kick_off ? Date.now() - period?.kick_off : 0;
                if (period.number === 2) {
                  time += 1000 * 60 * (game?.config?.half_duration || 45);
                }
                if (period.number === 3) {
                  time += 1000 * 60 * ((game?.config?.half_duration || 45) * 2);
                }
                if (period.number === 4) {
                  time += 1000 * 60 * 105;
                }
                let _id = Date.now();
                setAwayScorers([
                  ...awayScorers,
                  { time: time, _id, period: period.number },
                ]);
                updateGame({
                  id: game._id,
                  away_scorers: [
                    ...awayScorers,
                    { time: time, _id, period: period.number },
                  ],
                });
              }}
            >
              +
            </ScoreButton>
          </Row>
        </Column>

        <Column
          style={{ alignItems: "end" }}
          onClick={() => {
            if (selectedTeam) {
              setSelectedTeam();
            } else {
              setSelectedTeam(game.away_team);
            }
          }}
        >
          <TeamName>{game.away_team.name}</TeamName>
          <div>{game.away_formation?.name ?? "No formation selected"}</div>
        </Column>
      </Team>
    </TeamNamePanel>
  );
}
